const changeLog = [
  {
    version: "01.02.01",
    issues: 
    [
      { id: "CGNABC-30", description: "Added links for User Guide." },
      { id: "CGNABC-28", description: "Fixed problem with Log Detail text overrun." },
      { id: "CGNABC-27", description: "Changed Log Success column display to true/false icon." }
    ]
  },
  {
    version: "01.01.04",
    issues: [{ id: "", description: "Initial Deployment." }],
  }
];

export default changeLog;
